export const makeSrc = ({ root, url }): string =>
  !root || url?.startsWith('http') ? `${url}` : `${root}${url}`;
